var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.profileType == _vm.config.GFM_USER)?_c('div',[_c('GFMProfile')],1):((_vm.profileType = _vm.config.GLOFAS_USER))?_c('div',[_c('GlofasProfile')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }